import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { AccountStatusChip } from "components/AccountStatusChip";
import { ClaimsSelectionContent } from "components/claimSelection/ClaimsSelectionContent";
import { OneTimeSeatWarningDialog } from "components/OneTimeSeatWarningDialog";
import { hasOneTimeSeatChanges } from "data/hasOneTimeSeatChanges";
import { ServiceSummary, ServiceWithClaims, User } from "data/interfaces";
import { useEffect, useState } from "react";

interface ViewUserDialogProps {
  user: User;
  availableServices: ServiceSummary[];
  onClose: () => void;
  onConfirm: (user: User) => void;
}

const ViewUserDialog = ({
  user,
  availableServices,
  onClose,
  onConfirm,
}: ViewUserDialogProps) => {
  const [updatedUser, setUpdatedUser] = useState<User>({ ...user });
  const [selectedServicesWithClaims, setSelectedServicesWithClaims] = useState<
    ServiceWithClaims[]
  >(updatedUser.services);
  const [oneTimeSeatWarningOpen, setOneTimeSeatWarningOpen] = useState(false);

  useEffect(() => {
    setUpdatedUser((prev) => ({
      ...prev,
      services: selectedServicesWithClaims,
    }));
  }, [selectedServicesWithClaims]);

  const handleSaveClick = () => {
    if (
      hasOneTimeSeatChanges(
        availableServices,
        user.services,
        selectedServicesWithClaims,
      )
    ) {
      setOneTimeSeatWarningOpen(true);
    } else {
      onConfirm(updatedUser);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth={true}>
      <DialogTitle>
        User Information
        <Box
          sx={{
            border: 1,
            borderRadius: "16px",
            borderColor: "grey.400",
            mt: 2,
          }}
        >
          <Box sx={{ p: 2 }}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12}>
                <Typography sx={{ fontWeight: "bold" }}>{user.name}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>Email:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography>{user.email}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>Account status:</Typography>
              </Grid>
              <Grid item xs={8}>
                <AccountStatusChip accountStatus={user.accountStatus} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <ClaimsSelectionContent
          services={availableServices}
          selected={selectedServicesWithClaims}
          updateSelected={setSelectedServicesWithClaims}
          defaultSelected={user.services}
          selectedUsersCount={0}
        />
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={onClose}>
          Cancel
        </Button>
        <Button color="default" onClick={handleSaveClick}>
          Save
        </Button>
      </DialogActions>
      <OneTimeSeatWarningDialog
        open={oneTimeSeatWarningOpen}
        onClose={() => setOneTimeSeatWarningOpen(false)}
        onConfirm={() => {
          setOneTimeSeatWarningOpen(false);
          onConfirm(updatedUser);
        }}
      />
    </Dialog>
  );
};

export default ViewUserDialog;
